import React, { useEffect } from "react";


const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const AppLogout = ({ children }) => {
  let timer;
  useEffect(() => {
    localStorage.setItem("modelpopup_open", '0');
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        //console.log(timer);
        resetTimer();
        handleTimer();
      });
    });
  }, []);

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  const handleTimer = () => {
    timer = setTimeout(() => {

      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      logoutAction();
    }, globalThis.config.Settings.session_expired);

  };
  const logoutAction = () => {
    try{
      if (document.getElementById("modelpopup") == null) {
        localStorage.setItem("modelpopup_open", '1');
        document.getElementById("btnsessionexpired").click();
      }
      if (document.getElementById("modelpopup").parentElement.classList.contains("show") == true) {
        return;
      }
      else {
        document.getElementById("btnsessionexpired").click();
      }
    }catch{
      
    }
    

  };
  return children;
};

export default AppLogout;


